// Reduced-motion probe for the JS-driven animation in this feature (the pinned
// card's FLIP float). CSS transitions collapse in the stylesheet's media query;
// this covers the one animation CSS cannot express.

import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

export const useReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia(QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return;
        const list = window.matchMedia(QUERY);
        const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
        // Safari < 14 only has the deprecated listener API.
        if (list.addEventListener) {
            list.addEventListener('change', onChange);
            return () => list.removeEventListener('change', onChange);
        }
        list.addListener(onChange);
        return () => list.removeListener(onChange);
    }, []);

    return reduced;
};
